
<!--marcador lateral do container--><!--
<div style="position: absolute; left: 0px; z-index: 10000; width: 5px; height: 100%; background-color: rgb(46, 163, 80);"></div>
-->

<div style="border-left: 5px solid rgb(63, 81, 181); border-right: 5px solid rgb(63, 81, 181);" >

  <!--titulo da tela-->
  <div style="width: 100%; ">
      <div style="width: 100%; text-align: center;">
        <h1 style="font-size: 16px;  width: 100%;">
          <mat-card style=" margin-top: 0px;  height: 50px; color: rgb(130, 130, 130) ;font-weight: bold;
                            background-image: Radial-gradient(rgb(240, 240, 240), rgb(220, 220, 220), rgb(160, 160, 160)); 
                            border-radius: 0px 0px 0px 0px ;" >
            <div style="position: relative; top: -5px; "> 
              <mat-label>
                <img src="../../assets/img/icones/audio.png" width="30px">&nbsp;&nbsp;
                <b> Exemplo </b> 
                <i> (#TITULO#)</i>
              </mat-label>
            </div>
          </mat-card>
        </h1>
      </div>
    </div>
    



        
        

  <div class="backgroundTela">
    &nbsp;
  </div>
  
    
  <!--Definir o tamanho da tela-->
  <div style=" width: 100%; overflow:hidden; ">

    <mat-grid-list cols="2" rowHeight="200px" style="padding: 0px;">

      <mat-grid-tile colspan="2">
        
        <mat-card style="width: 100%;  padding: 0px; margin-top: 0px;" >
          
          <!--FAIXA AZULL SEPARADOR-->
          <mat-card-title>
            <mat-toolbar color="primary" style="margin-top: 0px; height: 15px;">
              <div>&nbsp;</div>
            </mat-toolbar> 
          </mat-card-title>
          
          <mat-card-content >
          
            #CONTEUDO#
            
          </mat-card-content>

          <!--FAIXA AZULL SEPARADOR-->
          <mat-card-title>
            <mat-toolbar color="primary" style="height: 5px; border-radius: 0px 0px 0px 0px;">
              <div>&nbsp;</div>
            </mat-toolbar> 
          </mat-card-title>
      

        </mat-card> 

      </mat-grid-tile>

    </mat-grid-list>

  </div>




 


<div>

  <!--FAIXA AZUL SEPARADOR-->
  <mat-card-title>
    <mat-toolbar color="primary" style="height: 30px; border-radius: 0px 0px 0px 0px;">
      <div>&nbsp;</div>
    </mat-toolbar> 
  </mat-card-title>

  <!--container ajustado dinamicamente-->
  <div id="divContainer" style="width: 99%;">
    <div id="divAdjustAutoHeight" style="overflow-y: auto;">
  
      <div style="margin-left: 10px; margin-right: 10px; height: 393px;  ">
  
        #DESCRIÇÃO OU LISTA#
    
      </div>
  
    </div>

  </div>

</div>

</div>